import { useQuery } from '@tanstack/react-query';
import { api } from '../lib/api';

export function useConfig() {
  const { data: config, isLoading, error } = useQuery({
    queryKey: ['config'],
    queryFn: api.getConfig,
    staleTime: Infinity, // Config doesn't change
  });

  return {
    config,
    itsmWebUrl: config?.itsmWebUrl || '',
    isLoading,
    error,
  };
}

/**
 * Get ITSM request URL
 */
export function getItsmRequestUrl(itsmWebUrl: string, requestId: number): string {
  return `${itsmWebUrl}/requests/${requestId}`;
}
